<template lang="html">
  <div class="section">
    <div class="Slide">
      <section>
        <header>
          <p><img src="../assets/images/top/img_support-header.svg" alt="児童家庭支援事業"></p>
          <h2>様々な環境で暮らす子どもたちを、<br class="visible-sm">地域の関係機関が<br>繋がりながら支援しています。</h2>
        </header>
        <div class="image">
          <img src="../assets/images/top/img_support.png" alt="">
        </div>
        <ul>
          <li>
            <img src="../assets/images/top/img_supportlist001.jpg" alt="">
            <h3>まちこや</h3>
            <p>開催場所：山代老人児童センター内<br>開催日時：第1・第3土曜日 午前10時30分～11時30分読み書き・そろばんの基本的なことや、大学生や中学生が、理科の実験や外国語などを通じて、知ることはワクワクドキドキ！を教えてくれます。</p>
          </li>
          <li>
            <img src="../assets/images/top/img_supportlist002.jpg" alt="">
            <h3>よりみちハウス</h3>
            <p>開催場所：石川県加賀市山代温泉山背台　寄り道ハウス内<br>
            開催日時：学校課業日　月・水・金　午後3時～5時<br>
            子どもたちが学校の帰り、宿題をしながら、町のおじちゃん、おばちゃんが話し相手になってくれます。</p>
          </li>
          <li>
            <img src="../assets/images/top/img_supportlist003.jpg" alt="">
            <h3>山代の子どもを育てる会</h3>
            <p>開催場所：石川県加賀市山代温泉北部1-233<br>
              開催日時：毎月第4月曜日　午後1時30分<br>
              子どもたちを取り巻く様々な機関が一堂に集まり、子どもたちの現状について情報交換をし、ゆるく繋がることで、情報の共有をします。</p>
          </li>
        </ul>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IdeaSlide',
};
</script>

<style lang="scss" scoped>
  @import '../assets/stylesheets/_mixin.scss';
  .Slide {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #98e5ff url("../assets/images/top/bg_support.png") right -12px top -83px no-repeat fixed;
    padding: 4rem 15px;
    @include media( md ) {
      width: 100vw;
      height: 100vh;
      padding: 0;
    }
  }
  section {
    @include media( md ) {
      width: 1000px;
    }
  }
  header {
    margin-bottom: 1.0rem;
    text-align: center;
    p {
      margin: 0;
      padding: 0;
      line-height: 0;
      img {
        text-align: center;
      }
    }
    @include media( md ) {
      display: flex;
      align-items: center;
      margin-bottom: 3.0rem;
      text-align: left;
      p {
        img {
          margin: 0 3.5rem 0 0;
        }
      }
    }
  }
  h2 {
    font-size: 1.7rem;
    line-height: 1.35;
    @include media( md ) {
      font-size: 3.0rem;
    }
  }
  .image {
    text-align: center;
  }
  ul {
    padding: 0;
    margin: 2rem 0 0;
    @include media( md ) {
      display: flex;
      justify-content: space-between;
      max-width: 1000px;
    }
  }
  li {
    width: 320px;
    &:not(:first-child) {
      margin-top: 2rem;
    }
    p {
      padding: 0 15px;
    }
    @include media( md ) {
      &:not(:first-child) {
        margin-top: 0;
      }
      p {
        padding: 0;
      }
    }
  }
  h3 {
    @include ShingoBold;
    font-size: 1.6rem;
    padding: 0 15px;
    @include media( md ) {
      padding: 0;
    }
  }
  p {
    font-size: 1.2rem;
    line-height: 1.5;
  }
</style>



// WEBPACK FOOTER //
// SupportSlide.vue?01bbd3ea